import { useCallback, useMemo, useState } from 'react';
import { TUMU_KAPALI, type GrupAcikligi, type GrupAyari } from '../rapor-ekrani/kolon';
import { doluAlanlar, grupAyari, type GruplamaAlani, type StokAlanlari } from './tipler';

/**
 * S345: stok raporlarının gruplama durumu. Seçenekler yalnız `urunler`de EN AZ BİR üründe dolu olan
 * alanlardır; seçilen alan veride yoksa (veri gelmedi ya da firma o kodu kullanmıyor) gruplama
 * uygulanmaz. Grup açıklığı burada durur ("Tümünü aç / kapat" filtre barında); alan değişince hepsi kapanır.
 */
export function useGruplama<S extends StokAlanlari>(urunler: readonly S[], varsayilan: GruplamaAlani | '') {
  const [secilen, setSecilen] = useState<GruplamaAlani | ''>(varsayilan);
  const [aciklik, setAciklik] = useState<GrupAcikligi>(TUMU_KAPALI);
  const dolu = useMemo(() => doluAlanlar(urunler), [urunler]);
  const alan: GruplamaAlani | '' = secilen !== '' && dolu.includes(secilen) ? secilen : '';
  const grup = useMemo<GrupAyari<S> | null>(() => (alan === '' ? null : grupAyari<S>(alan)), [alan]);
  const sec = useCallback((yeni: GruplamaAlani | '') => {
    setSecilen(yeni);
    setAciklik(TUMU_KAPALI);
  }, []);
  return { dolu, alan, sec, grup, aciklik, setAciklik };
}
